export const CLEAR_CHARACTER = '\u{2715}'
